
import { Component, Vue } from "vue-property-decorator";
import {
  ZuzhijiagouList2,
  doctorDetail,
  AddComposeUser,
} from "@/request/doctor";
import MainHeader from "../../../main/components/main-header/main-header.vue";
import NavLeft from "../../../main/components/nav-left/nav-left.vue";
import Pagination from "@/components/paginaiton.vue";
declare module "vue/types/vue" {
  interface Vue {
    [key: string]: any;
  }
}
@Component({
  components: {
    MainHeader,
    NavLeft,
    Pagination,
  },
})
export default class ComposeUser extends Vue {
  private H: any = "";
  private id: any = "";
  private institution: any = {};
  private institutions: any[] = [];
  private jueseOpt: any = [];
  private user: any = {
    institution_id: "",
    机构: {
      institution_id: "",
    },
    角色: "",
  };

  private account: any = {};
  private accounts: any = {};
  private ifShowAccountSearch: boolean = false;
  private searchAccountText: any = "";
  private roles: any[] = [];
  private xiangguanzhanghus: any[] = [];
  private centers: any[] = [];
  private levelChange(e: any) {
    this.getRoleInInstitution(e);
  }
  /**
   * @description 获取医生账户详情
   */
  private getDetail() {
    const params: any = {
      doctor_id: this.id,
      source: "pc管理",
    };
    doctorDetail(this, params).then((data: any) => {
      this.user = data;
      this.user.institution_id = data["机构"]["institution_id"];
      this.getRoleInInstitution(data["机构"]["institution_id"]);
    });
  }
  /**
   * @description 获得可选的组织结构列表
   */
  private getZuzhijiagouList(text: any) {
    return new Promise((resolve, reject) => {
      ZuzhijiagouList2(this)
        .then((data: any) => {
          this.institutions = data;
          resolve(data);
        })
        .catch(() => {
          reject();
        });
    });
  }
  /**
   * @description 获得机构和角色的关系
   */
  private getRoleInInstitution(id: any) {
    if (!id) {
      return;
    }
    if (this.institutions.length > 0) {
      // 寻找level
      let result: any = {};
      this.institutions.forEach((items: any) => {
        if (id === items.institution_id) {
          result = items;
        } else {
          items.sub_institutions.forEach((item: any) => {
            if (id === item.institution_id) {
              result = item;
            } else {
              if (item.sub_institutions) {
                item.sub_institutions.forEach((ele: any) => {
                  if (id === ele.institution_id) {
                    result = ele;
                  }
                });
              }
            }
          });
        }
      });
      this.user["机构"] = result;
      if (result.level === 1) {
        this.jueseOpt = ["项目负责人"];
      } else if (result.level === 2) {
        this.jueseOpt = ["医院管理员"];
      } else if (result.level === 3) {
        this.jueseOpt = ["高级医生", "普通医生"];
      }
    } else {
      this.getZuzhijiagouList("").then(() => {
        // 寻找level
        let result: any = {};
        this.institutions.forEach((items: any) => {
          if (id === items.institution_id) {
            result = items;
          } else {
            items.sub_institutions.forEach((item: any) => {
              if (id === item.institution_id) {
                result = item;
              } else {
                if (item.sub_institutions) {
                  item.sub_institutions.forEach((ele: any) => {
                    if (id === ele.institution_id) {
                      result = ele;
                    }
                  });
                }
              }
            });
          }
        });
        this.user["机构"] = result;
        if (result.level === 1) {
          this.jueseOpt = ["项目负责人"];
        } else if (result.level === 2) {
          this.jueseOpt = ["医院管理员"];
        } else if (result.level === 3) {
          this.jueseOpt = ["高级医生", "普通医生"];
        }
      });
    }
  }
  /**
   * @description 保存
   */
  private save() {
    if (!this.user["institution_id"]) {
      this.$message.error("请选择所属层级");
      return;
    }
    if (!this.user["角色"]) {
      this.$message.error("请选择角色");
      return;
    }
    if (!this.user["用户名"]) {
      this.$message.error("请填写账户名");
      return;
    }
    if (!this.user["用户名"]) {
      this.$message.error("请填写账户名");
      return;
    }
    if (!this.user["姓名"]) {
      this.$message.error("请填写姓名");
      return;
    }
    if (!this.user["性别"]) {
      this.$message.error("请选择性别");
      return;
    }
    if (!this.user["手机号"]) {
      this.$message.error("请填写手机号");
      return;
    }
    if (this.user["手机号"].length !== 11) {
      this.$message.error("手机号长度不正确");
      return;
    }
    if (!this.user["职称"]) {
      this.$message.error("请选择职称");
      return;
    }
    if (!/^1(3|4|5|6|7|8|9)\d{9}$/.test(this.user["手机号"])) {
      this.$message.error("手机号格式不正确");
      return;
    }
    if (!this.user["状态"]) {
      this.$message.error("请选择状态");
      return;
    }
    const params = JSON.parse(JSON.stringify(this.user));
    delete params.institution_id;
    AddComposeUser(this, params).then((data: any) => {
      const text = this.user["doctor_id"] ? "编辑" : "新增";
      this.$message.success(text + "成功");
      this.$router.back();
    });
  }
  /**
   * @description 初始化
   */
  private mounted() {
    this.H = document.body.clientHeight - 50 - 14 - 14 - 14;
    this.getZuzhijiagouList(" ");
    if (this.$route.query.id) {
      this.id = this.$route.query.id;
      this.getDetail();
    }
  }
}
